module.exports = __webpack_public_path__ + "media/img/logos/takgov-018a87eb8b7e2f663597c1346541ba16.png";